'use client';

import { icons } from 'lucide-react';

export const IconBlock = (
  {
    name,
    color,
    size,
    className,
  }: {
    name: keyof typeof icons;
    color?: string;
    size?: number;
    className?: string;
  }) => {
  const LucideIcon = icons[name as keyof typeof icons];

  if (!LucideIcon) return '';
  return <LucideIcon color={color} size={size} className={className} />;
};
